import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import * as Shared from '../shared/shared';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MainNavComponent } from '../main-nav/main-nav.component';

import { NgMaterialMultilevelMenuModule, MultilevelMenuService } from 'ng-material-multilevel-menu';
import { FullCalendarModule } from '@fullcalendar/angular';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import { NgxSpinnerModule } from 'ngx-spinner';
FullCalendarModule.registerPlugins([interactionPlugin, dayGridPlugin]);


@NgModule({
  declarations: [
    DashboardComponent,
    MainNavComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    Shared.SharedMaterial,
    NgMaterialMultilevelMenuModule,
    FullCalendarModule,
    NgxSpinnerModule
  ],
  exports:[
    MainNavComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [
    HttpClientModule,
    MultilevelMenuService
  ],
})
export class DashboardModule { }
